export const getTrackValues = (
  width: string,
  configuration: string
): {
  defaultValue: string;
  maxValue: string;
  minValue: string;
} => {
  const multiplier = configuration === 'configuration-single' ? 1 : 2;
  return {
    defaultValue: String(Number(width) * 2 * multiplier),
    maxValue: String(Number(width) * 3 * multiplier),
    minValue: String(Number(width) * 1.5 * multiplier),
  };
};
